// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"24":"536b1e01","71":"248414c2","249":"b6125745","791":"cdf8aca4","886":"c7b1e83f"}[chunkId] + ".js";
};